module.exports = __webpack_public_path__ + "static/media/25.f363563c.mp3";